import { Segment, SegmentEntity, WithBaseEntitySchema } from '@40seas/models';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';
import { SearchBusinessQuery, SearchBusinessResult } from '@40seas/entities/search';
import { z } from 'zod';
import { Executor, FromSchema } from '@40seas/entities/common';
import { SearchBusinessQuerySchema, SearchBusinessResultSchema } from '@40seas/entities/business-verification';

export const AtradiusCompanySchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        searchQuery: SearchBusinessQuerySchema.optional(),
        searchResult: SearchBusinessResultSchema.optional(),
        match: BusinessMatchSchema.optional(),
        currentRating: z.number().optional(),
        currentClass: z.number().optional(),
    }),
).strict();

export class AtradiusCompany extends FromSchema(AtradiusCompanySchema) implements SegmentEntity {
    id: string;
    buyer: string;
    searchQuery?: SearchBusinessQuery;
    searchResult?: SearchBusinessResult;
    match?: BusinessMatch;
    currentRating?: number;
    currentClass?: number;
    createdAt?: Date;
    updatedAt?: Date;
    segments?: Segment[];
    tenantId: string;
    createdBy?: Executor;
    timeline?: { [status: string]: { updatedAt: Date } };
    metadata?: { [key: string]: string };
    seller?: string;
}
